/* Joii bundles: reads the Revy (Unlimited Bundles) widgets and adds bundle labels to
   product cards and the product page. Moved out of snippets/joii-header-navigation.liquid,
   where it was output once per nav bar. Loaded once, deferred, from theme-variables.liquid. */
window.allBundles = [];
  window.bundlesLoaded = false;
  document.addEventListener('DOMContentLoaded', function () {
    //console.log('test');
    const joiiBundles = document.querySelector('#joii-bundles-data');

    function waitForElement(selector, callback) {
      // Already on the page: no need to watch
      let existing = document.querySelector(selector);
      if (existing) { callback(existing); return; }

      let observer = new MutationObserver((mutations, obs) => {
        let element = document.querySelector(selector);
        if (element) {
          callback(element);
          obs.disconnect(); // Stop observing once found
        }
      });

      observer.observe(document.body, { childList: true, subtree: true });
      // Pages without a bundle never get the wrapper: stop watching after 20s
      setTimeout(() => observer.disconnect(), 20000);
    }

    // Wait for #joii-bundles-data to be added to the DOM
    waitForElement("#revy-bundles-wrapper", (bundWrap) => {
      setTimeout(() => {
        //console.log("Found revy:", bundWrap);
        const fetchAllBundles = bundWrap.children;
        var allBundles = [];
        Array.from(fetchAllBundles).forEach(bund => {
          if (bund.id == 'rbu-sb') { // Standard Bundle
            allBundles.push({
              type: 'standard',
              title: bund.__vue__.bundle.title,
              link: `/products/${bund.__vue__.bundle.products[0].handle}`,
              products: bund.__vue__.bundle.products.map(prod => prod.id) // Store product IDs
            });
          }
          if (bund.id == 'rbu-mc' && bund?.__vue__?.collections) { // Mix Match Collection
            var prodIDs = [];
            var collHandle = '';
            Array.from(bund.__vue__.collections).forEach(bundColl => {
              var bCollProds = bundColl.products;
              collHandle = bundColl.handle;
              if (Array.isArray(bCollProds)) {
                Array.from(bCollProds).forEach(bCollProd => {
                  prodIDs.push(bCollProd.id);
                });
              } else {
                //console.error('Products is not an array:', bCollProds);
              }
            });
            allBundles.push({
              type: 'mix-match',
              title: bund.__vue__.bundle.title,
              //link: `/collections/${bund.__vue__.bundle.mix_match_collections.handle}`,
              link: `/collections/${collHandle}`,
              products: prodIDs // Store product IDs
            });
          }
        });

        window.allBundles = allBundles;
        window.bundlesLoaded = true;
        //console.log("bundles ready");
        //console.log(window.allBundles);

        function updateProductCards() {
          const prodCards = document.querySelectorAll('.joii-product-card-item');

          if (prodCards) {
            prodCards.forEach(pCard => {
              if (!pCard.classList.contains('pcl')) {
                var hasLabel = false;
                var pOfferLabelCont = pCard.querySelector('.joii-offer-label-cont');
                var pCardBadges = pCard.querySelector('.product-card-badges');
                var checkBadges = pCardBadges.getElementsByClassName('product-badge');
                //console.log(pCard.getAttribute('joii-id'));

                function newOfferLabel (dealName,labelLink,labelCont) {
                  offerLabelCont = document.createElement("p");
                  offerLabel = document.createElement("a");
                  offerLabelCont.classList.add('joii-offer-label');

                  offerLabel.innerHTML = `
                  <svg class="icon icon-discount" viewBox="0 0 12 12" height="14" width="14" style="margin-right: 5px;">
                    <path fill="#ca1b08" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path>
                  </svg>
                  <span>${dealName}</span>
                  `;
                  offerLabel.href = labelLink;
                  offerLabelCont.appendChild(offerLabel);
                  labelCont.appendChild(offerLabelCont);

                  hasLabel = true;
                }

                function addDealBadge(pCardBadges) {
                  var priceDropExists = false;
                  if (checkBadges) {
                    Array.from(checkBadges).forEach(badge => {
                      if (badge.classList.contains('pricedrop')) {
                        priceDropExists = true;
                      }
                    });
                  }
                  if (!priceDropExists) {
                    pBadge = document.createElement("span");
                    pBadge.classList.add('product-badge');
                    pBadge.classList.add('pricedrop');
                    pBadge.textContent = 'Offer';
                    pCardBadges.appendChild(pBadge);
                  }
                }

                allBundles.forEach(bundle => {
                  bundle.products.forEach(bundProd => {
                    if (pCard.getAttribute('joii-id') == bundProd) {
                      let dealName = bundle.title.includes(" on ") 
                        ? bundle.title.split(" on ")[0] 
                        : bundle.title;
                      newOfferLabel(dealName,bundle.link,pOfferLabelCont);
                      addDealBadge(pCardBadges);
                    }
                  });
                });

                var dealMsg = pCard.getAttribute('joii-deal-msg');
                if (dealMsg && !hasLabel) {
                  var dealColUrl = pCard.getAttribute('joii-deal-url');
                  var dealMessage = pCard.getAttribute('joii-deal-msg');
                  newOfferLabel(dealMessage,dealColUrl,pOfferLabelCont);
                  addDealBadge(pCardBadges);
                }

                if (!hasLabel && pOfferLabelCont) {
                  var fallbackMsg = pOfferLabelCont.getAttribute("fallback-msg");
                  var fallbackLink = pOfferLabelCont.getAttribute("fallback-link");
                  if (fallbackMsg !== "") {
                      offerLabel.innerHTML = `
                      <svg class="icon icon-discount" viewBox="0 0 12 12" height="14" width="14" style="margin-right: 5px;">
                        <path fill="#ca1b08" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path>
                      </svg>
                      <span>${fallbackMsg}</span>
                      `;
                      offerLabel.href = fallbackLink;
                      offerLabelCont.appendChild(offerLabel);
                      pOfferLabelCont.appendChild(offerLabelCont);
                      if (checkBadges) {
                        Array.from(checkBadges).forEach(badge => {
                          if (badge.classList.contains('pricedrop')) {
                            priceDropExists = true;
                          }
                        });
                      }
                      if (!priceDropExists) {
                        pBadge = document.createElement("span");
                        pBadge.classList.add('product-badge');
                        pBadge.classList.add('pricedrop');
                        pBadge.textContent = 'Offer';
                        pCardBadges.appendChild(pBadge);
                      }
                      hasLabel = true;
                  }
                }

                pCard.classList.add('pcl');
              }
            });
          } else {

          }
        }
        function updateProductPage() { 
          //console.log("Product Page Deals...");
          var activeLabels = ""
          var joiiDealCont = document.querySelector('.joii-deal-container');
          if (joiiDealCont) {
            var existingDealItem = joiiDealCont.querySelector(".joii-deal-item");
            var pPageBadges = document.querySelector('.product-page-badges');
            var hasLabel = false;
            if (pPageBadges) {
              var checkBadges = pPageBadges.getElementsByClassName('product-badge');
              var prodWrapper = document.querySelector('.product__wrapper');
              var priceDropExists = false;
              allBundles.forEach(bundle => {
                var bundApplied = false;
                bundle.products.forEach(bundProd => {
                if (!bundApplied && prodWrapper.getAttribute('joii-id') == bundProd) {
                  if (checkBadges) {
                    Array.from(checkBadges).forEach(badge => {
                      if (badge.classList.contains('pricedrop')) {
                        priceDropExists = true;
                      }
                    });
                  }
                  if (!priceDropExists) {
                    pBadge = document.createElement("span");
                    pBadge.classList.add('product-badge');
                    pBadge.classList.add('pricedrop');
                    pBadge.textContent = 'Offer';
                    pPageBadges.appendChild(pBadge);
                  }
                  if (!existingDealItem && joiiDealCont && !activeLabels.includes(bundle.title)) {
                    offerItem = document.createElement("div");
                    offerItem.classList.add('joii-deal-item');
                    offerItem.innerHTML = '<svg class="icon icon-discount" style="margin-right: 1rem; width: 16px; height: 16x;" viewBox="0 0 12 12" height="14" width="14"><path fill="#ca1b08" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path></svg><svg class="joii-deal-item-arrow" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h24v24h-24z" fill="none"></path><path fill="currentColor" stroke="currentColor" d="m9.29 6.71c-.39.39-.39 1.02 0 1.41l3.88 3.88-3.88 3.88c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41l-4.59-4.59c-.38-.38-1.02-.38-1.41.01z"></path></svg>'
                    offerLabel = document.createElement("a");
                    offerLabel.textContent = bundle.title;
                    offerLabel.classList.add('joii-deal');
                    if (!bundle.link.includes('/products/')) {
                      offerLabel.href = bundle.link;
                    }
                    offerItem.appendChild(offerLabel);
                    joiiDealCont.appendChild(offerItem);
                    joiiDealCont.classList.remove('hidden');
                    activeLabels = `${activeLabels},${bundle.title}`;
                  }
                  bundApplied = true;
                  hasLabel = true;
                }
              });
              if (!hasLabel && joiiDealCont) {
                //console.log(" !hasLabel && joiiDealCont ");
                var fallbackMsg = joiiDealCont.getAttribute("fallback-msg");
                var fallbackLink = joiiDealCont.getAttribute("fallback-link");
                if (!existingDealItem && fallbackMsg !== "" && !activeLabels.includes(fallbackMsg)) {
                  if (checkBadges) {
                    Array.from(checkBadges).forEach(badge => {
                      if (badge.classList.contains('pricedrop')) {
                        priceDropExists = true;
                      }
                    });
                  }
                  if (!priceDropExists) {
                    pBadge = document.createElement("span");
                    pBadge.classList.add('product-badge');
                    pBadge.classList.add('pricedrop');
                    pBadge.textContent = 'Offer';
                    pPageBadges.appendChild(pBadge);
                  }
                  if (joiiDealCont) {
                    offerItem = document.createElement("div");
                    offerItem.classList.add('joii-deal-item');
                    offerItem.innerHTML = '<svg class="icon icon-discount" style="margin-right: 1rem; width: 16px; height: 16x;" viewBox="0 0 12 12" height="14" width="14"><path fill="#ca1b08" fill-rule="evenodd" d="M7 0h3a2 2 0 0 1 2 2v3a1 1 0 0 1-.3.7l-6 6a1 1 0 0 1-1.4 0l-4-4a1 1 0 0 1 0-1.4l6-6A1 1 0 0 1 7 0m2 2a1 1 0 1 0 2 0 1 1 0 0 0-2 0" clip-rule="evenodd"></path></svg><svg class="joii-deal-item-arrow" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg"><path d="m0 0h24v24h-24z" fill="none"></path><path fill="currentColor" stroke="currentColor" d="m9.29 6.71c-.39.39-.39 1.02 0 1.41l3.88 3.88-3.88 3.88c-.39.39-.39 1.02 0 1.41s1.02.39 1.41 0l4.59-4.59c.39-.39.39-1.02 0-1.41l-4.59-4.59c-.38-.38-1.02-.38-1.41.01z"></path></svg>'
                    offerLabel = document.createElement("a");
                    offerLabel.textContent = fallbackMsg;
                    offerLabel.classList.add('joii-deal');
                    offerLabel.href = fallbackLink;
                    offerItem.appendChild(offerLabel);
                    joiiDealCont.appendChild(offerItem);
                    joiiDealCont.classList.remove('hidden');
                    activeLabels = `${activeLabels},${fallbackMsg}`;
                  }
                }
                hasLabel = true;
              }

            });
            var prodFlicks = document.querySelectorAll(".product-grid-wrapper.flickity-enabled");
            prodFlicks.forEach(pFlick => {
              var flickityInstance = Flickity.data(pFlick);
              if (flickityInstance) {
                var currentIndex = flickityInstance.selectedIndex;
                flickityInstance.reloadCells();
                flickityInstance.resize();
                flickityInstance.select(currentIndex, false, true);
                //console.log('flickity reloaded');
              }
            });
          }
        }




      }
      updateProductPage();
      updateProductCards();
      //updateRipProductCards();
      //updateRipProductPage();
    }, 1000);

  });
});
